import { useEffect, useRef, useState } from 'react';

export default function useBulkOrderCarousel({ itemCount, paused, disabled }) {
  const [carouselStart, setCarouselStart] = useState(itemCount);
  const [carouselAnimating, setCarouselAnimating] = useState(true);
  const [visiblePackageCards, setVisiblePackageCards] = useState(() => {
    if (typeof window === 'undefined') return 3;
    if (window.innerWidth < 768) return 1;
    if (window.innerWidth < 1024) return 2;
    return 3;
  });
  const carouselLockedRef = useRef(false);

  const moveCarousel = (delta) => {
    if (itemCount === 0 || carouselLockedRef.current) return;
    carouselLockedRef.current = true;
    setCarouselAnimating(true);
    setCarouselStart((prev) => prev + delta);
  };

  const handleTransitionEnd = () => {
    if (carouselStart >= itemCount * 2) {
      setCarouselAnimating(false);
      setCarouselStart((prev) => prev - itemCount);
    } else if (carouselStart < itemCount) {
      setCarouselAnimating(false);
      setCarouselStart((prev) => prev + itemCount);
    } else {
      carouselLockedRef.current = false;
    }
  };

  useEffect(() => {
    const updateVisibleCards = () => {
      const width = window.innerWidth;
      setVisiblePackageCards(width < 768 ? 1 : width < 1024 ? 2 : 3);
    };

    updateVisibleCards();
    window.addEventListener('resize', updateVisibleCards);
    return () => window.removeEventListener('resize', updateVisibleCards);
  }, []);

  useEffect(() => {
    if (paused || disabled || itemCount === 0) return undefined;

    const timer = window.setInterval(() => {
      if (carouselLockedRef.current) return;
      carouselLockedRef.current = true;
      setCarouselAnimating(true);
      setCarouselStart((prev) => prev + 1);
    }, 4200);

    return () => window.clearInterval(timer);
  }, [disabled, itemCount, paused]);

  useEffect(() => {
    if (carouselAnimating) return undefined;

    const raf = window.requestAnimationFrame(() => {
      setCarouselAnimating(true);
      carouselLockedRef.current = false;
    });

    return () => window.cancelAnimationFrame(raf);
  }, [carouselAnimating]);

  return {
    carouselAnimating,
    carouselStart,
    handleTransitionEnd,
    moveCarousel,
    visiblePackageCards,
  };
}
